import { useCallback, useRef, useState } from 'react'

const TOAST_DURATION_MS = 3500

export function useToast() {
  const [toast, setToast] = useState(null)
  const timeoutRef = useRef(null)

  const showToast = useCallback((type, msg) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setToast({ type, msg })
    timeoutRef.current = setTimeout(() => setToast(null), TOAST_DURATION_MS)
  }, [])

  return { toast, showToast }
}
